<style>
    
    .el-card {
        box-shadow: none;
    }
    .el-table {
        margin-top: 10px;
    }
    .card-item {
    	margin: 20px 5px;
        line-height: 36px;
    }
</style>
<template>
	<div class="ly-bill">
		<!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">{{pageName}}</h1>
            </el-col>
            <el-col :span="12" class="tr">
            </el-col>
        </div>
        <el-card class="box-card mt10">
            <el-row class="card-item"><el-col :span="24" style="color:red;">温馨提示：只能每个自然月顺序扎帐或反扎帐，且扎帐时候会对单据与库存总值灯数据进行检查，检查通过才能操作成功。</el-col></el-row>
        	<div class="el-row card-item" >
                <el-col :span="8">
                    选择扎账报表:
                    <el-select v-model="selectIndex" v-if="zhazhangOptions.length > selectIndex">
                        <el-option
                            v-for="(item, k) in zhazhangOptions"
                            :key="k"
                            :label="item.name"
                            :value="k">
                        </el-option>
                     </el-select>
                     <template v-else>无</template>
                </el-col>
        	</div>
            <div class=" el-row card-item">                
        		<el-col :span="8">
        			当前操作时间范围 :&nbsp;
                    <template v-if="zhazhangOptions.length > selectIndex">{{zhazhangOptions[selectIndex]['zhazhang_time']}}</template>
                    <template v-else>无</template>
        		</el-col>
                <el-col :span="16">
                    <el-button v-if="zhazhangOptions[selectIndex]['zhazhang_time']" type="primary" @click="zhazhang(1)">扎帐</el-button>
                    <el-button v-else type="primary" disabled>扎帐</el-button>
                </el-col>
        	</div>
        	<div class=" el-row card-item">
        		<el-col :span="8">
        			当前操作时间范围 :&nbsp;
                    <template v-if="zhazhangOptions.length > selectIndex">{{zhazhangOptions[selectIndex]['fan_zhazhang_time']}}</template>
                    <template v-else>无</template>
        		</el-col>
                <el-col :span="16">
                    <el-button v-if="zhazhangOptions[selectIndex]['fan_zhazhang_time'] " type="primary" @click="zhazhang(2)" >反扎帐</el-button>
                    <el-button v-else type="primary" disabled>反扎帐</el-button>
                </el-col>
        	</div>
        </el-card>
        <!-- 处理记录 start -->
        <el-card class="box-card mt15">
            <template slot='header'>
            <div>
                <span>处理记录</span>
            </div>
            </template>
            <p class="f12 mt10 ctext" v-for="el in history">
                {{el}}
            </p>
        </el-card>
        <!-- 处理记录 end -->
	</div>
</template>
<script>
	import {mapGetters} from 'vuex'
	/**
	* 扎帐
	* @author wxq
	* @time 2018.12.11
	*/
	export default {
		computed: {
            ...mapGetters('route', [
                'currRoute'
            ])
        },
		data () {
			return {
				pageName: "",
                // zhazhangtime: '',
                // fan_zhazhangtime: '',
                // zhazhangtimeShow: '', // 仅页面显示用
                // fan_zhazhangtimeShow: '', // 页面显示用
                history: [],
                // 扎账报表选择， 2020-03-30 zjs修改，原来只有一个选择，现在要用下拉选择
                zhazhangOptions: [],
                selectIndex: 0 // 扎账报表选择索引
			}
		},
		mounted () {
            this.queryzhazhangtime()
            this.queryzhazhanglog()
            // 获得当前页面的名称
            this.pageName = this.currRoute.name
        },
		methods: {
            /**
            * 获取扎帐时间
            */
            queryzhazhangtime () {
                this.$api.query('api/zhazhangtime').then((rs) => {
                    this.zhazhangOptions = rs
                    // this.zhazhangtime = rs.zhazhang_time || ''
                    // this.zhazhangtimeShow = rs.zhazhang_time ? (rs.zhazhang_time.replace(/-/, '年') + '月') : ''
                    // this.fan_zhazhangtime = rs.fan_zhazhang_time
                    // this.fan_zhazhangtimeShow = rs.fan_zhazhang_time ? (rs.fan_zhazhang_time.replace(/-/, '年') + '月') : ''
                })
            },
            /**
            * 获取扎帐操作记录
            */
            queryzhazhanglog () {
                this.$api.query('api/zhazhanglog').then((rs) => {
                    this.history = rs
                })
            },
            /**
            * 扎帐操作
            */  
            zhazhang (type) {
                let option = this.zhazhangOptions[this.selectIndex]
                var formdata = {
                    time: type > 1 ? option.fan_zhazhang_time : option.zhazhang_time,
                    type: type,
                    type_zz: option.type
                }
                this.$api.create('api/zhazhang', formdata).then((rs) => {
                    this.queryzhazhangtime()
                    this.queryzhazhanglog()
                    this.$message({
                      message: '操作已成功！',
                      type: 'success'
                    })
                }).catch((error) => { // 捕捉错误处理  
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            }
		}
	}
</script>